import styled from "styled-components";

export const HeaderContainer = styled.div`
  @media (max-width: 850px) {
    text-align: center;
  }
`;

export const TabContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  width: 100%;
  border-bottom: 2px solid #fe2f67;

  @media (max-width: 850px) {
    flex-direction: column;
    height: auto;
  }
`;

export const BackdropContainer = styled.div`
  width: 100%;
  height: 250px;
  background-color: black;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 1500px) {
    height: 200px;
  }
`;

export const BackdropPicture = styled.img`
  height: 100%;
  width: auto;
  max-width: 100%;
  object-fit: cover;
  object-position: 0% 30%;
`;

export const InnerHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
  margin: 2% 0;
  position: relative;
  text-align: left;

  @media (max-width: 850px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  @media (max-width: 530px) {
    margin-bottom: 2.1rem;
  }
`;

export const ProfilePicture = styled.img`
  background-color: white;
  width: 125px;
  height: 125px;
  padding: 1%;
  margin-right: 2rem;
  border-radius: 50%;
  box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.3);
  vertical-align: top;
  object-fit: contain;
  overflow: hidden;

  @media (max-width: 1500px) {
    width: 115px;
    height: 115px;
  }
  @media (max-width: 1350px) {
    width: 105px;
    height: 105px;
  }
  @media (max-width: 1150px) {
    width: 95px;
    height: 95px;
  }
  @media (max-width: 850px) {
    margin: 0 auto 1rem auto;
  }
  @media (max-width: 650px) {
    width: 80px;
    height: 80px;
  }
  @media (max-width: 500px) {
    width: 70px;
    height: 70px;
  }
  @media (max-width: 375px) {
    width: 60px;
    height: 60px;
  }
  @media (max-width: 280px) {
    width: 50px;
    height: 50px;
  }
`;

export const DescriptionContainer = styled.div`
  font-family: "Inter", sans-serif;
  text-align: left;
  @media (min-width: 851px) {
    width: 50%;
  }

  @media (max-width: 850px) {
    text-align: center;
    width: 90%;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const Username = styled.h2`
  margin-top: 8px;
  font-size: 1.5rem;
  font-weight: 600;

  @media (max-width: 850px) {
    margin-top: 0;
  }
  @media (max-width: 650px) {
    font-size: 1.75rem;
  }
`;

export const Description = styled.h5`
  font-weight: 500;
  margin-top: 7px;
`;

export const Miscellaneous = styled.h5`
  color: gray;
  font-weight: 400;
  margin-top: 7px;

  @media (max-width: 650px) {
    font-size: 0.9rem;
  }
`;

export const TabBarContainer = styled.div`
  width: 100%;
  border-bottom: 2px solid #fe2f67;
`;

export const TabsAndButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TabsWrapper = styled.div`
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 10px;
  white-space: nowrap;
`;

export const JoinCommunityButton = styled.button`
  background-color: white;
  color: #fe2f67;
  border: 1px solid #fe2f67;
  border-radius: 5px;
  padding: 2px 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  &:hover {
    background-color: #f5f5f5;
  }
`;

export const FollowButton = styled.button`
  background-color: #fe2f67;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 2px 20px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 25px;
  &:hover {
    background-color: #c02778;
  }
`;

export const FollowingButton = styled.button`
  background-color: #e0e0e0;
  color: #333333;
  border: none;
  border-radius: 5px;
  padding: 2px 20px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 25px;
  &:hover {
    background-color: #b0b0b0;
  }
`;
